<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Subject Diaries</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="d-flex">
    <div class="ibox col-md-6 p-0 m-1">
          <div class="ibox-title style_2">
            <h5 class="float-left">Activities</h5>
          </div>
          <div class="ibox-content horizondalscroll tableminheight-subject">
            <div class="table-responsive custom-table-wrapper-subject">
              <table class="table table-hover mb-0">
                <thead class="table-light">
                  <tr>
                     <th style="max-width:70px;">Subject ID</th>
                    <th style="max-width:70px;">Visit No</th>
                    <th style="max-width:70px;">Form Name</th>
                    <th style="max-width:70px;">Form Status</th>
                    <th style="max-width:70px;">Expected Date</th>
                    <th class="text-center align-middle">Add</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sub in notcompletedforms" :key="sub.id">
                    <td class="text-wrap" style="max-width:70px;">{{ sub.patientNo }}</td>
                    <td class="text-wrap" style="max-width:70px;">{{ sub.visitNo }}</td>
                    <td class="text-wrap" style="max-width:70px;">{{ sub.templateName }}</td>
                    <td>
                      <span
                        class="badge"
                        :style="{ backgroundColor: sub.formStatusHex, color: '#333' }"
                      >
                        <i :class="`fa fa-${sub.icon} me-1`"></i>
                        {{ sub.formStatus }}
                      </span>
                    </td>
                    <td class="text-wrap" style="max-width:70px;">{{ filter(sub.visitDate) }}</td>
                    <td class="text-center align-middle"
              >
                <a
                  @click.prevent="
                    EditForm(sub, false)
                  "
                >
                  <i class="fa fa-plus-square edit-delete"></i
                ></a>
              </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

    </div>
    <div class="ibox col-md-6 p-0 m-1">
          <div class="ibox-title style_2">
            <h5 class="float-left">Recent Submissions</h5>
          </div>
          <div class="ibox-content horizondalscroll tableminheight-subject">
           <div class="table-responsive custom-table-wrapper-subject">
              <table class="table table-hover mb-0">
                <thead class="table-light">
                  <tr>
                     <th style="max-width:70px;">Subject ID</th>
                    <th style="max-width:70px;">Visit No</th>
                    <th style="max-width:70px;">Form Name</th>
                    <th style="max-width:70px;">Form Status</th>
                    <th style="max-width:90px;">Completed Date</th>
                    <th class="text-center align-middle">View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sub in completedforms" :key="sub.id">
                    <td class="text-wrap" style="max-width:70px;">{{ sub.patientNo }}</td>
                    <td class="text-wrap" style="max-width:70px;">{{ sub.visitNo }}</td>
                    <td class="text-wrap" style="max-width:70px;">{{ sub.templateName }}</td>
                    <td>
                      <span
                        class="badge"
                        :style="{ backgroundColor: sub.formStatusHex, color: '#333' }"
                      >
                        <i :class="`fa fa-${sub.icon} me-1`"></i>
                        {{ sub.formStatus }}
                      </span>
                    </td>
                    <td class="text-wrap" style="max-width:70px;">{{ filter(sub.visitCompletedDate) }}</td>
                    <td class="text-center align-middle"
              >
                <a
                  @click.prevent="
                    showformmodel(sub.formId)
                  "
                >
                  <i class="fa fa-eye editicon"></i
                ></a>
              </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

    </div>
    </div>
  </div>
<showformmodel
  v-if="setshowFormModal"
    :formid="currentform"
    currentformstatus="Completed"
    @closeformModal="closeformModal()"
  />
</template>
<script src="./subject_diaries.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}



/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.minheight {
    min-height: 460px;
    max-height: 600px;
    overflow: auto;
}
.custom-table-wrapper-subject{
    max-height: 450px;
    overflow: auto;
}
.tableminheight-subject{
  min-height: 485px;
}
.custom-table-wrapper-subject thead th {
  position: sticky;
  top: 0;
  background-color: #fff; 
  z-index: 10;            
  font-weight: bold;
}
</style>
